<template>
     <b-container class="d-flex p-0">
        <div v-if="IsEditor" 
            class="d-flex align-items-center my-auto pr-2 h5"> 
            <b-icon-gear 
                style="pointer-events: all; cursor: pointer;" />
                <!-- @click="changeParameter(fieldSet)" /> -->
        </div>
        <div class="w-25 my-auto pr-1">{{ Parameter.Label }}</div>
        <b-form-select plain
                class="rounded w-75"
                value-field="Key"
                text-field="Value"
                :options="Parameter.Options"
                v-model="Parameter.Selected"
                :key="'ParameterColumn' + Parameter.Name"
                :class="'border-' + Variant">
            <template v-if="Parameter.EmptyText != null && Parameter.EmptyText != ''" #first>
                <b-form-select-option :value="Parameter.EmptyText" disabled>{{ Parameter.EmptyText }}</b-form-select-option>
            </template>
        </b-form-select>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import ComboBoxField from '../Class/ComboBoxField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class ComboBoxItem extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        @Prop()
        public Parameter!: ComboBoxField;

        mounted(){
            this.$emit('child-event', 'mounted');
        }

        updated(){
            this.$emit('child-event', 'updated');
        }
    }

</script>

<style scoped>
</style>